module.exports = __webpack_public_path__ + "static/media/ProximaNova-Semibold.3625e925.ttf";